{
  "demo": {
    "searchInputLabel": "Søk",
    "searchButton": "Søk",
    "readyDescription": "Bruk søkefunksjonen for å finne rader.",
    "emptyMessage": "Ingen treff.",
    "emptyDescription": "Prøv et annet søk.",
    "loadingMessage": "Søker...",
    "errorMessage": "Kunne ikke hente rader. Prøv igjen.",
    "countLabel": "Viser {{visible}} av {{total}} rader",
    "pagination": {
      "rowsPerPage": "Rader per side",
      "all": "Alle",
      "previousPage": "Forrige side",
      "nextPage": "Neste side"
    }
  }
}
